var exports = {
  "K": "RecentMentionsPage.module__icon___RmY0WW",
};

module.exports = exports;
